function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Double from '../../../../java/lang/Double';
var MathUtil = /*#__PURE__*/function () {
  function MathUtil() {
    _classCallCheck(this, MathUtil);
    MathUtil.constructor_.apply(this, arguments);
  }
  return _createClass(MathUtil, [{
    key: "getClass",
    value: function getClass() {
      return MathUtil;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "log10",
    value: function log10(x) {
      var ln = Math.log(x);
      if (Double.isInfinite(ln)) return ln;
      if (Double.isNaN(ln)) return ln;
      return ln / MathUtil.LOG_10;
    }
  }, {
    key: "min",
    value: function min(v1, v2, v3, v4) {
      var min = v1;
      if (v2 < min) min = v2;
      if (v3 < min) min = v3;
      if (v4 < min) min = v4;
      return min;
    }
  }, {
    key: "clamp",
    value: function clamp() {
      if (typeof arguments[2] === 'number' && typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        var x = arguments[0];
        var min = arguments[1];
        var max = arguments[2];
        if (x < min) return min;
        if (x > max) return max;
        return x;
      } else if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
        var _x = arguments[0];
        var _min = arguments[1];
        var _max = arguments[2];
        if (_x < _min) return _min;
        if (_x > _max) return _max;
        return _x;
      }
    }
  }, {
    key: "wrap",
    value: function wrap(index, max) {
      if (index < 0) {
        return max - -index % max;
      }
      return index % max;
    }
  }, {
    key: "max",
    value: function max() {
      if (arguments.length === 3) {
        var v1 = arguments[0];
        var v2 = arguments[1];
        var v3 = arguments[2];
        var _max2 = v1;
        if (v2 > _max2) _max2 = v2;
        if (v3 > _max2) _max2 = v3;
        return _max2;
      } else if (arguments.length === 4) {
        var _v = arguments[0];
        var _v2 = arguments[1];
        var _v3 = arguments[2];
        var v4 = arguments[3];
        var _max3 = _v;
        if (_v2 > _max3) _max3 = _v2;
        if (_v3 > _max3) _max3 = _v3;
        if (v4 > _max3) _max3 = v4;
        return _max3;
      }
    }
  }, {
    key: "average",
    value: function average(x1, x2) {
      return (x1 + x2) / 2.0;
    }
  }]);
}();
export { MathUtil as default };
MathUtil.constructor_ = function () {};
MathUtil.LOG_10 = Math.log(10);